"use client";

import { FC } from "react";
import { Box } from "@chakra-ui/react";
import { Markdown } from "@zerotofinals/design-system";
import BasicPageLayout from "./PageLayout/BasicPageLayout";

type Props = {
  title: string;
  content: string;
};

const MarkdownPage: FC<Props> = ({ title, content }) => (
  <BasicPageLayout title={title}>
    <Box w="100vw" maxWidth={600} px={5} mx="auto" mb={10}>
      <Markdown>{content}</Markdown>
    </Box>
  </BasicPageLayout>
);

export default MarkdownPage;
